import React from 'react';

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import { ReactComponent as Succeeded } from '../../assets/images/modal-succeeded.svg';
import Deleted from '../../assets/images/modal-deleted.svg';
import Error from '../../assets/images/modal-error.svg';
import Warning from '../../assets/images/modal-warning.svg';
import Updated from '../../assets/images/modal-updated.svg';
import WrongMail from '../../assets/images/modal-wrong-mail.svg';
import WrongPassword from '../../assets/images/modal-wrong-password.svg';

const ConfirmationModal = ({
  img,
  icon,
  open,
  handleClose,
  title,
  text,
  onConfirm,
  confirmText,
  cancelText,
  confirmStartIcon,
  cancelStartIcon,
}) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    borderRadius: 4,
    '&:focus': {
      outline: 'none',
    },
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="flex items-center justify-center">
          {img && (
            <img
              src={
                img === 'succeeded'
                  ? Succeeded
                  : img === 'deleted'
                    ? Deleted
                    : img === 'error'
                      ? Error
                      : img === 'warning'
                        ? Warning
                        : img === 'updated'
                          ? Updated
                          : img === 'wrong-mail'
                            ? WrongMail
                            : img === 'wrong-password'
                              ? WrongPassword
                              : img
              }
              alt="modal"
              className="w-[100px] h-[100px] m-5"
            />
          )}
          {!img && icon && (
            <div className="w-[100px] h-[100px] m-5 flex justify-center items-center">
              {icon}
            </div>
          )}
        </div>
        <h2
          id="modal-modal-title"
          className="text-lg font-medium leading-6 text-gray-900 text-center"
        >
          {title}
        </h2>
        <p
          id="modal-modal-description"
          className="mt-2 text-sm text-gray-500 text-center"
        >
          {text}
        </p>
        {confirmText && cancelText && onConfirm && (
          <div className="mt-4 w-full flex justify-evenly items-center">
            <Button
              startIcon={cancelStartIcon}
              onClick={handleClose}
              variant="outlined"
              style={{ width: '50%', margin: '5px' }}
            >
              {cancelText}
            </Button>
            <Button
              startIcon={confirmStartIcon}
              onClick={onConfirm}
              variant="contained"
              style={{ width: '50%', margin: '5px' }}
            >
              {confirmText}
            </Button>
          </div>
        )}
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;

/* 

- Usage:

<ConfirmationModal
  img="warning"
  icon={<DirectionsBike color="secondary" fontSize="large" />}
  open={open}
  handleClose={() => setOpen(false)}
  title="iomerkoyuncu'yu sil"
  onConfirm={() => {console.log('Deleted')}}
  confirmText="SİL"
  cancelText="İPTAL"
  confirmStartIcon={<Delete />}
  cancelStartIcon={<Cancel />}
  text="iomerkoyuncu'yu silmek istediğinize emin misiniz? Bu işlem geri alınamaz."
/> 
*/
